import type { QueryClient } from "@tanstack/react-query";
import {
  APPOINTMENT_BOOKINGS_BULK_MAX_IDS,
  appointmentBookingsBulkQueryKey,
  uniqueSortedAppointmentIds,
} from "@/features/appointments/utils/appointment-bookings-query";
import { fetchAndSeedAppointmentBookingsBulk } from "@/features/appointments/utils/fetch-appointment-bookings-bulk";

/** Cap matches the bulk API max; extra IDs are chunked inside the fetch helper. */
const MAX_APPOINTMENT_BOOKING_PREFETCH = APPOINTMENT_BOOKINGS_BULK_MAX_IDS;

export async function prefetchAppointmentBookingsCheck(
  appointmentIds: number[],
  queryClient: QueryClient,
  accessToken: string,
) {
  const uniqueIds = uniqueSortedAppointmentIds(appointmentIds).slice(
    0,
    MAX_APPOINTMENT_BOOKING_PREFETCH,
  );

  if (uniqueIds.length === 0) return queryClient;

  await queryClient.prefetchQuery({
    queryKey: appointmentBookingsBulkQueryKey(uniqueIds),
    queryFn: () =>
      fetchAndSeedAppointmentBookingsBulk(queryClient, accessToken, uniqueIds),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
